<div class="loadApp" [ngClass]="{'afterLoad':isAfter$() && userDetails$()}">
    <img *ngIf="client == 'directq'" class="image-load-logo" src="/assets/images/header/questionnaireSite-{{client}}-dark.svg">
    <img *ngIf="client != 'directq'" class="image-load-logo" src="/assets/images/header/questionnaireSite-{{client}}-logo.svg">
    <p *ngIf="client != 'directq'" class="header-load">{{title}}</p>
    <div class="grediant grediant-{{client}}"></div>
</div>
<div class="tostes high">
    <que-tost-display class="tost-item" *ngFor="let tost of tostesSigHigh$()" [tost]="tost" (removeTost)="removeTost(tost)"></que-tost-display>
</div>
<div class="tostes">
    <que-tost-display class="tost-item" *ngFor="let tost of tostesSig$()" [tost]="tost" (removeTost)="removeTost(tost)"></que-tost-display>
</div>
<router-outlet></router-outlet>